import { Animation } from '@repo/database-core';
import { DatabaseWearable } from '@repo/types-client';

/**
 * Interface for pose data structure.
 * @interface PoseData
 * @property {Animation[]} getAnimations - The list of animations.
 */
interface PoseData {
  getAnimations: Animation[];
}

/**
 * Filters animations for a given pose data to return only those with position 'HEAD'.
 * @function filterHeadAnimations
 * @param {PoseData} data - The pose data containing animations.
 * @returns {Animation[]} An array of animations where the position is 'HEAD'.
 */
export const filterHeadAnimations = (data: PoseData): Animation[] => {
  // Filtering animations with position 'HEAD'
  return data.getAnimations.filter(
    (animation: Animation) => animation.position === 'HEAD',
  );
};

/**
 * Filters wearable animations to return those within a specific layer range.
 * @function filterHeadWearableAnimations
 * @param {DatabaseWearable[]} data - Array of wearables with their animations.
 * @returns {Animation[]} An array of animations where the layer is within 50 to 70.
 */
export const filterHeadWearableAnimations = (
  data: DatabaseWearable[],
): Animation[] => {
  return data.flatMap((wearable) =>
    // Filtering animations where the layer is within the range of 50 to 70
    wearable.animations.filter(
      (animation) => animation.layer >= 50 && animation.layer <= 70,
    ),
  );
};

/**
 * Filters wearable animations to hide to return those within a specific layer range.
 * @function filterHeadWearableAnimationsToHide
 * @param {DatabaseWearable[]} data - Array of wearables with their animations.
 * @returns {Animation[]} An array of animations where the layer is within 50 to 70.
 */
export const filterHeadWearableAnimationsToHide = (
  data: DatabaseWearable[],
): Animation[] => {
  return data.flatMap((wearable) =>
    // Filtering animations where the layer is within the range of 50 to 70
    wearable.animationsToHide.filter(
      (animation) => animation.layer >= 50 && animation.layer <= 70,
    ),
  );
};
